import * as React from 'react'
import {H1} from '@frontrow/console/src/components/typography'

import {SalesReportsPage} from '@frontrow/console/src/components/pages/sales-reports-page/sales-reports-page'

export function SalesReportsContainer(): React.ReactElement {
  return (
    <React.Fragment>
      <H1>Sales Reports</H1>
      <SalesReportsPage />
    </React.Fragment>
  )
}
